const hyphenChar = " - ";
export const getLeagueNameWithoutCountry = (league, regionName) => {
    if (!league.name) {
        return "";
    }
    if (league.name.indexOf(hyphenChar) === -1) {
        return league.name;
    }
    let leagueName = league.name.replace(regionName, "").replace(/  /g, " ");
    if (leagueName.startsWith(hyphenChar) || leagueName.endsWith(hyphenChar)) {
        leagueName = leagueName.replace(hyphenChar, "");
    }
    return leagueName.replace(/^ /, "");
};
//# sourceMappingURL=getLeagueNameWithoutCountry.js.map